import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart, registerables } from 'chart.js';
import { Box, useTheme } from '@mui/material';

Chart.register(...registerables);

interface MonthlyData {
  month: string;
  year: string;
  totalWeight: number;
  totalShipment: number;
  exportShipments: number;
  importShipments: number;
}

interface BarChartProps {
  data: MonthlyData[];
}

const ExportImportBarChart: React.FC<BarChartProps> = ({ data }) => {
  // Extracting the labels for the x-axis
  const labels = data?.map(item => `${item.month} ${item.year}`);

  // Extracting the data for export and import shipments
  const exportData = data?.map(item => item.exportShipments);
  const importData = data?.map(item => item.importShipments);
  const theme = useTheme();

  // Defining the bar chart data
  const barChartData = {
    labels,
    datasets: [
      {
        label: 'Export Shipments',
        data: exportData,
        backgroundColor: theme.palette.primary.main,
      },
      {
        label: 'Import Shipments',
        data: importData,
        backgroundColor: theme.palette.secondary.main,
      },
    ],
  };

  // Configuring the chart options
  const options = {
    scales: {
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: 'No. of Shipments', // Label for the y-axis
        },
      },
      x: {
        title: {
          display: true,
          text: 'Months', // Label for the x-axis
        },
      },
    },
    plugins: {
      legend: {
        display: false, // Show legend to differentiate bars
      },
    },
  };

  return (
    <Box>
      <Box
        sx={{ display: 'flex', justifyContent: 'flex-end', gap: '100px', alignItems: 'center', marginBottom: '10px' }}
      >
        <p style={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
          <span
            style={{
              borderRadius: '50%',
              backgroundColor: theme.palette.primary.main,
              display: 'inline-block',
              width: '15px',
              height: '15px',
              textAlign: 'center',
            }}
          ></span>
          <span>Export</span>
        </p>
        <p style={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
          <span
            style={{
              borderRadius: '50%',
              backgroundColor: theme.palette.secondary.main,
              display: 'inline-block',
              width: '15px',
              height: '15px',
              textAlign: 'center',
            }}
          ></span>
          <span>Import</span>
        </p>
      </Box>
      <Bar data={barChartData} options={options} />
    </Box>
  );
};

export default ExportImportBarChart;
